<template>
  <div>
    <vs-popup :title="$t('Shelves')" :active.sync="showModal">
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-2">
          <vs-button
            @click="createShelve()"
            class="bg_l_green"
            v-has-permission="permission108"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateNewShelve") }}
          </vs-button>
        </div>
      </div>
      <shelve-modify-popup
        :show="ShelveModifyPopup"
        :model="shelveModalModel"
        @finish="onShelvefinish"
      ></shelve-modify-popup>
      <div>
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('ShelveName'), sort: 'ShelveName' },
            { title: $t('ShelveId'), sort: 'ShelveId' },
            { title: $t('AutomationCode'), sort: 'AutomationCode' },
            { title: $t('Action') }
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width:32%">
              {{ row.name }}
            </td>
            <td style="width:15%">
              {{ row.id }}
            </td>
            <td style="width:32%">
              {{ row.automationCode }}
            </td>
            <td style="width:32%">
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                @click.prevent="editShelve(row)"
                class="ml-4 d-inline"
                v-has-permission="permission109"
              ></vs-button>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteShelve(row.id, model.id)"
                class="d-inline"
                v-has-permission="permission110"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss">
body[dir="rtl"] .vs-popup--content {
  overflow-y: scroll !important;
}
</style>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import ShelveModifyPopup from "./ShelveModifyPopup.vue";

export default {
  name: "warehouseManagement_Warehouses_shelvePopup",
  components: {
    DataGrid,
    ShelveModifyPopup
  },
  props: {
    show: { default: false }
  },
  data() {
    return {
      permission108: "AddShelve",
      permission109: "ModifyShelve",
      permission110: "RemoveShelve",
      ShelveModifyPopup: false,
      shelveModalModel: {},
      gridDataSource: { data: [] },
      gridSearchData: {
        keyword: ""
      },
      model: {}
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      removeShelve: "warehouse/removeShelve"
    }),
    onShelvefinish(warehouse) {
      if (warehouse) {
        this.load(warehouse);
      }
      this.ShelveModifyPopup = false;
    },

    ////Open shelveModal In Create Mode
    createShelve() {
      this.shelveModalModel = {
        isModify: false,
        warehouseId: this.model.id,
        isActive: true
      };
      this.ShelveModifyPopup = true;
    },
    //Open shelveModal In Edit Mode
    editShelve(model) {
      this.shelveModalModel = {
        shelveId: model.id,
        warehouseId: this.model.id,
        isModify: true,
        name: model.name,
        isActive: model.isActive,
        automationCode: model.automationCode
      };
      this.ShelveModifyPopup = true;
    },
    ////delete shelve
    deleteShelve(shelveId, warehouseId) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.removeShelve({ shelveId, warehouseId }).then(r => {
            this.load(r);
          });
        }
      });
    },
    ////
    load(model) {
      this.model = Object.assign({}, model);
      this.gridDataSource.data = model.shelveQueries;
      this.$refs.grid.renderGrid();
      setTimeout(() => {}, 0);
    }
  }
};
</script>
